import { PaperProps } from 'components/shared/surfaces/Paper/Paper.types';
import { getSpacing, muiStyles } from 'utils/design';

export const useStyles = muiStyles<PaperProps>((theme, { innerSpacing = 0, outerSpacing = 0, background }) => ({
  paper: {
    padding: getSpacing(theme, innerSpacing),
    margin: getSpacing(theme, outerSpacing),
    background: background ? background : 'white',
  },
}));
